// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/huelsenfeder/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const huelsenfederDE: PageEntry = {
  id: "post.huelsenfeder",
  locale: "de",
  slug: "huelsenfeder",
  seo: {
    title: "Glossar: Hülsenfeder einfach erklärt | Dietz GmbH",
    description: "Eine Hülsenfeder ist eine spezielle Art von Feder, die in einer zylindrischen Form mit einer Hülse oder einem Mantel umwickelt ist. Diese Konstruktion bietet zusätzlichen Schutz fü",
  },
  type: "post",
  h1: "Glossar: Hülsenfeder einfach erklärt",
  intro: "Eine Hülsenfeder ist eine spezielle Art von Feder, die in einer zylindrischen Form mit einer Hülse oder einem Mantel umwickelt ist. Diese Konstruktion bietet zusätzlichen Schutz für die Feder und ermöglicht eine präzise Steuerung der Federbewegung. Hülsenfedern werden oft in Anwendungen eingesetzt, in denen eine gleichmäßige Kraftverteilung und eine reduzierte Reibung erforderlich sind. Die Auswahl des richtigen Materials und der richtigen Konstruktion für Hülsenfedern ist entscheidend, um ihre Leistung und Langlebigkeit in verschiedenen Anwendungen zu gewährleisten.",
  blocks: [

  ],
};
